var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { TagadaStatusEnum } from '@sgdf/client';
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { emit } from '../../internal/event';
import { withResizeObserver } from '../../internal/with-resize-observer';
import styles from './MeetingTable.styles';
import { headers, getFormattedMeeting } from '../meeting-gestionnaire-table/meeting-gestionnaire-table';
import '../../atoms/table/sgdf-table.js';
import '../../atoms/tag/tag.js';
import '../../atoms/text-bloc/text-bloc.js';
const SKELETON_MEETINGS = [
    {
        id: '',
        label: '-',
        created_at: new Date('2022-02-02T20:35:56.575249Z'),
        end_date: new Date('2021-09-30T00:00:00Z'),
        meeting_type_id: null,
        meeting_type: {
            id: '',
            label: '-',
            modules_default: [],
        },
        place_id: null,
        place: {
            id: '5fbb366e-7501-495f-b7aa-6ac8f3a748cc',
            label: '-',
            address: '-',
            zipcode: '59000',
            city: '-',
        },
        start_date: new Date('2021-09-30T00:00:00Z'),
        structure_organisatrice_id: null,
        structure_organisatrice: {
            structure_code: 'test',
            id: '',
            label: '-',
        },
        updated_at: new Date('2022-04-02T09:20:52.287600Z'),
        code_analytic: '',
        supervisors: [],
        intranet_id: '7613',
        num_agreement_js: '',
        status: 'open',
        modules: [],
        tracks: [],
        daytime_min: '07:00',
        daytime_max: '23:30',
        tagada_status: TagadaStatusEnum.Untested,
        tagada_password: 'password',
        tagada_participants_last_sync: new Date('2021-09-30T00:00:00Z'),
        tagada_avis_last_sync: new Date('2021-09-30T00:00:00Z'),
        tagada_total_candidates: 40,
        tagada_synced_candidates: 20,
        has_opinions: true,
        ndays: 1,
    },
];
export class SgdfMeetingTable extends withResizeObserver(LitElement) {
    constructor() {
        super(...arguments);
        this.skeleton = false;
    }
    onResize({ width }) {
        this._width = width;
    }
    connectedCallback() {
        this.onTableClick = this.onTableClick.bind(this);
        super.connectedCallback();
        addEventListener('sgdf-table:click', this.onTableClick);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    async onTableClick(event) {
        const { detail } = event;
        event.stopPropagation();
        emit(this, 'sgdf-meeting-table:click', { detail });
    }
    async onCardClick(index) {
        emit(this, 'sgdf-meeting-table:click', {
            detail: this.meetings[index],
        });
    }
    render() {
        // NOTE: This value is arbitrary, we don't have a better solution for now
        // It's a bit more than the width of the table in french (which is the largest) and with both links (download and pay)
        // The table width is mostly stable since the with of the amount is fixed and the rest is almost always the same number of characters
        const bigMode = this._width && this._width > 700;
        const skeleton = this.skeleton || this.meetings == null;
        const meetings = skeleton ? SKELETON_MEETINGS : this.meetings;
        const formattedMeeting = meetings.map(meeting => getFormattedMeeting(meeting));
        if (skeleton === false && meetings.length == 0) {
            return html `
                <section>
                    <sgdf-text-bloc
                        >Il n'y a aucun stage disponible pour le
                        moment.</sgdf-text-bloc
                    >
                </section>
            `;
        }
        return bigMode
            ? this._renderBig(formattedMeeting)
            : this._renderSmall(skeleton, formattedMeeting);
    }
    _renderBig(formattedMeeting) {
        return html `
            <sgdf-table
                .columns=${headers}
                .data=${formattedMeeting}
                .tableWidth=${this._width}
                .noDataMessage=${'Aucun stage disponible'}
            >
            </sgdf-table>
        `;
    }
    _renderSmall(skeleton, meetingList) {
        return html ` <div class="meeting-list">
            ${meetingList.map((meeting, i) => html `
                    <div class="card" @click=${() => this.onCardClick(i)}>
                        <div class="card-body">
                            <h5 class="card-title ${classMap({ skeleton })}">
                                ${meeting.name}
                            </h5>
                            ${meeting.type
            ? html `<span class="${classMap({ skeleton })}"
                                      ><sgdf-meeting-type
                                          .name=${meeting.type}
                                      ></sgdf-meeting-type>
                                  </span>`
            : null}
                            <span
                                class="${classMap({ skeleton })}"
                                aria-label="Lieu"
                                ><sgdf-icon
                                    library="picto"
                                    name="signesCommuns-Tente"
                                ></sgdf-icon
                                >${meeting.place}<br
                            /></span>
                            <sgdf-icon name="calendar"></sgdf-icon
                            >${meeting.period}<br />
                            <span
                                class="${classMap({ skeleton })}"
                                aria-label="Structure Organisatrice"
                                ><sgdf-icon name="user-group"></sgdf-icon
                                >${meeting.structure}<br
                            /></span>

                            ${meeting.status == 'open'
            ? html `<sgdf-tag success
                                      >${meeting.formatted_status}</sgdf-tag
                                  >`
            : html `<sgdf-tag warning
                                      >${meeting.formatted_status}</sgdf-tag
                                  >`}
                        </div>
                    </div>
                `)}
        </div>`;
    }
}
SgdfMeetingTable.styles = styles;
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfMeetingTable.prototype, "skeleton", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfMeetingTable.prototype, "meetings", void 0);
//# sourceMappingURL=MeetingTable.js.map